import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { FolhaPagamento } from "../api/dto/folha-pagamento";
import { PagamentoFolhaRequest } from "../api/dto/folha-pagamento-request";

@Injectable({
  providedIn: "root",
})
export class FolhaPagamentoService {

  constructor(private http: HttpClient) { }

  private url: string = UrlServidor.URL_BASE + "folha-pagamento";

  listarRegistros(empresaId?: number, competencia?: Date, tipoFolha?: string): Observable<FolhaPagamento[]> {

    let params = new HttpParams();
    if (competencia) {
      params = params.set("competencia", competencia.toISOString());
    }
    if (tipoFolha) {
      params = params.set("tipo", tipoFolha)
    }

    return this.http.get<FolhaPagamento[]>(
      this.url + "/empresa/" + empresaId,
      { params: params }
    );
  }

  listarRegistrosAPagar(empresaId?: number, competencia?: Date): Observable<FolhaPagamento[]> {

    let params = new HttpParams();
    if (competencia) {
      params = params.set("competencia", competencia.toISOString());
    }

    return this.http.get<FolhaPagamento[]>(
      this.url + "/empresa/" + empresaId + "/a-pagar", { params: params });
  }

  pagarFolha(empresaId?: number, pagamentoFolha?: PagamentoFolhaRequest): Observable<void> {
    return this.http.post<void>(this.url + "/empresa/" + empresaId + "/pagar", pagamentoFolha)
  }

  excluir(id?: number, tipoFolha?: string): Observable<void> {
    let params = new HttpParams();

    if (tipoFolha) {
      params = params.set("tipoFolha", tipoFolha)
    }
    return this.http.delete<void>(this.url + "/" + id, { params })
  }

  excluirPagamento(idFolha?: number, idFluxo?: number, tipoFolha?: string): Observable<void> {
    let params = new HttpParams();

    if (tipoFolha) {
      params = params.set("tipoFolha", tipoFolha)
    }
    return this.http.delete<void>(`${this.url}/${idFolha}/pagamento/${idFluxo}`, { params })
  }

  obterRelatorio(empresaId?: number, tipoFolha?: string, competencia?: Date): Observable<Blob> {

    let params = new HttpParams();
    if (tipoFolha) {
      params = params.set('tipoFolha', tipoFolha);
    }
    if (competencia) {
      params = params.set('competencia', competencia.toISOString());
    }

    return this.http.get(`${this.url}/empresa/${empresaId}/relatorio`,
      { params: params, responseType: 'blob' });
  }


}
